import _defineProperty from '@babel/runtime/helpers/defineProperty';
import texts from './ToggleButtonGroup.texts.js';
import { ToggleButtonContainer, ResultIndicator } from './style.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import useUniqueId from '../../hooks/useUniqueId.js';
import useGlobals from '../../hooks/useGlobals.js';
import ToggleButton from '../ToggleButton/ToggleButton.js';

var ToggleButtonGroup = function ToggleButtonGroup(_ref) {
  var items = _ref.items,
    handleChange = _ref.handleChange,
    _ref$allButtonText = _ref.allButtonText,
    allButtonText = _ref$allButtonText === void 0 ? null : _ref$allButtonText,
    _ref$allButtonBehavio = _ref.allButtonBehaviour,
    allButtonBehaviour = _ref$allButtonBehavio === void 0 ? 'reflectAndToggleState' : _ref$allButtonBehavio,
    _ref$removeAllButton = _ref.removeAllButton,
    removeAllButton = _ref$removeAllButton === void 0 ? false : _ref$removeAllButton;
  var uniqueId = useUniqueId('toggle-button-group');
  var _useGlobals = useGlobals(),
    culture = _useGlobals.culture;
  var allButtonLabel = allButtonText !== null && allButtonText !== void 0 ? allButtonText : texts[culture].all;
  var areAllValuesConsistent = function areAllValuesConsistent(targetValue) {
    return items === null || items === void 0 ? void 0 : items.map(function (item) {
      return item.value;
    }).every(function (value) {
      return value === targetValue;
    });
  };
  var allValuesTrue = areAllValuesConsistent(true);
  var allValuesFalse = areAllValuesConsistent(false);
  var getResetValues = function getResetValues(value) {
    return items === null || items === void 0 ? void 0 : items.reduce(function (acc, item) {
      acc[item.id] = value;
      return acc;
    }, {});
  };
  var getToggleValue = function getToggleValue(itemId, value) {
    return _defineProperty({}, itemId, !value);
  };
  var getAllButtonCheckedState = function getAllButtonCheckedState() {
    if (allValuesTrue && allButtonBehaviour === 'reflectAndToggleState') {
      return true;
    }
    if ((allValuesTrue || allValuesFalse) && allButtonBehaviour === 'resetState') {
      return true;
    }
    return false;
  };
  var getTotalNumberOfResults = function getTotalNumberOfResults() {
    var hasNumberOfResults = items.some(function (item) {
      return Object.prototype.hasOwnProperty.call(item, 'numberOfResults') && typeof item.numberOfResults === 'number';
    });
    if (!hasNumberOfResults) {
      return undefined;
    }
    return items.reduce(function (total, item) {
      if (Object.prototype.hasOwnProperty.call(item, 'numberOfResults') && typeof item.numberOfResults === 'number') {
        return total + item.numberOfResults;
      }
      return total;
    }, 0);
  };
  var handleAllButtonChange = function handleAllButtonChange() {
    if (allButtonBehaviour === 'resetState') {
      handleChange(getResetValues(false));
    } else {
      handleChange(getResetValues(!getAllButtonCheckedState()));
    }
  };
  var handleItemButtonChange = function handleItemButtonChange(itemId, itemValue) {
    handleChange(getToggleValue(itemId, itemValue));
  };
  var totalResults = getTotalNumberOfResults();
  return /*#__PURE__*/jsxs(ToggleButtonContainer, {
    children: [!removeAllButton && items.length > 1 && /*#__PURE__*/jsxs(ToggleButton, {
      id: uniqueId,
      disabled: totalResults === 0,
      onChange: function onChange() {
        return handleAllButtonChange();
      },
      checked: getAllButtonCheckedState(),
      children: [allButtonLabel, totalResults >= 0 && /*#__PURE__*/jsx(ResultIndicator, {
        children: "(".concat(totalResults, ")")
      })]
    }), items.map(function (item) {
      return /*#__PURE__*/jsxs(ToggleButton, {
        id: "".concat(uniqueId, "-").concat(item.id),
        disabled: item.numberOfResults === 0,
        checked: item.value,
        onChange: function onChange() {
          return handleItemButtonChange(item.id, item.value);
        },
        children: [item.toggleButtonChildren, item.numberOfResults >= 0 && /*#__PURE__*/jsx(ResultIndicator, {
          children: "(".concat(item.numberOfResults, ")")
        })]
      }, item.id);
    })]
  });
};
var ToggleButtonGroup$1 = ToggleButtonGroup;

export { ToggleButtonGroup$1 as default };
//# sourceMappingURL=ToggleButtonGroup.js.map
